const getGeneralResourceFile = require('utils/LanguageLocale').getGeneralResourceFile;

module.exports = function getResource(label, vars = []) {
    const getGeneralResource = getGeneralResourceFile();
    const resources = {
        conversationsLabel: 'Every beauty talks. Ask questions, post answers, and be part \n of conversations with real people like you.',
        featuredPostsTitle: 'Featured Posts',
        myPostsTitle: 'My Posts',
        postsTitle: 'Posts',
        noUserConversationsLabel: `${vars[1]} hasn’t posted any conversations yet.`,
        exploreAllConversationsLabel: 'Explore all conversations',
        startConversationLabel: 'Start a Conversation'
    };

    return resources[label] || getGeneralResource(label);
};
